<template>
	<frontend-layout>
		<Head>
			<title>
				{{
					$i18n.locale == "zh-TW"
						? softwareCategoryTitle
						: softwareCategoryTitleEn
				}}
				- {{ $t("softwareDownload") }} -
				{{ $t("siteTitle") }}
			</title>
		</Head>
		<template #header>
			<h1 class="page-title p-0">
				{{ $t("softwareDownload") }} &nbsp;-&nbsp;{{
					$i18n.locale == "zh-TW"
						? softwareCategoryTitle
						: softwareCategoryTitleEn
				}}
			</h1>
		</template>

		<template #breadcrumb>
			<div class="pageInfo mb-2 p-1">
				<div class="page-breadcrumb float-sm-right">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/'"
								:class="{
									active: $page.url === '/',
								}">
								{{ $t("home") }}
							</InertiaLink>
						</li>
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/download'"
								:class="{
									active: $page.url === '/download',
								}">
								{{ $t("softwareDownload") }}
							</InertiaLink>
						</li>
						<li class="breadcrumb-item">
							{{
								$i18n.locale == "zh-TW"
									? softwareCategoryTitle
									: softwareCategoryTitleEn
							}}
						</li>
					</ol>
				</div>
			</div>
		</template>

		<section class="content ck-content" id="software">
			<div class="container">
				<template v-if="softwares.length > 0">
					<div class="ts-grid is-stackable is-4-columns">
						<div
							v-for="software in softwares"
							:key="software.software_id"
							class="column">
							<a
								href=""
								class="ts-box ts-text is-undecorated"
								data-bs-toggle="modal"
								:data-bs-target="
									'#s' + software.software_id + '-modal'
								">
								<div class="ts-image is-centered">
									<img
										:src="
											'/softimg/' + software.software_id
										" />
								</div>
								<div class="ts-content">
									<div
										class="ts-text is-bold is-big"
										v-if="$i18n.locale == 'zh-TW'">
										{{ software.title }}
									</div>
									<div class="ts-text is-bold is-big" v-else>
										{{ software.title_en }}
									</div>
									<!-- <div class="ts-text is-truncated" v-html="$i18n.locale == 'zh-TW' ? software.introduction.slice(0, 40) : category.introduction_en.slice(0, 80)"></div> -->
								</div>
							</a>

							<!-- Modal -->
							<div
								class="modal fade"
								:id="'s' + software.software_id + '-modal'"
								tabindex="-1"
								:aria-labelledby="software.title + '-label'"
								aria-hidden="true">
								<div
									class="
										modal-dialog
										modal-xl
										modal-dialog-scrollable
										modal-dialog-centered
									">
									<div class="modal-content">
										<div class="modal-header">
											<h2
												class="ts-title"
												:aria-labelledby="
													software.title + '-label'
												">
												{{
													$i18n.locale == "zh-TW"
														? software.title
														: software.title_en
												}}
											</h2>
											<button
												type="button"
												class="btn-close"
												data-bs-dismiss="modal"
												aria-label="Close"></button>
										</div>
										<div class="modal-body">
											<div class="container-fluid p-0">
												<div class="software">
													<div class="content">
														<div
															class="
																ts-grid
																is-compact
															">
															<img
																class="
																	column
																	is-4-wide
																"
																width="100%"
																:src="`/softimg/${software.software_id}`"
																:alt="`thumbnail_${software.title_en}`" />

															<div
																class="
																	column
																	is-8-wide
																">
																<table
																	class="
																		ts-table
																		align-middle
																		table-hover
																	">
																	<thead>
																		<tr>
																			<th>
																				{{
																					$t(
																						"download.downloadFile"
																					)
																				}}
																			</th>
																			<th>
																				{{
																					$t(
																						"download.hash"
																					)
																				}}
																			</th>
																		</tr>
																	</thead>
																	<tbody>
																		<template
																			v-if="
																				software
																					.files
																					.length ==
																					0 &&
																				software
																					.links
																					.length ==
																					0
																			">
																			<tr
																				class="
																					software-files
																				">
																				<td
																					colspan="2"
																					class="
																						not-found
																					">
																					{{
																						$t(
																							"download.noFile"
																						)
																					}}
																				</td>
																			</tr>
																		</template>
																		<template
																			v-else
																			v-for="file in software.files"
																			:key="
																				file.software_file_id
																			">
																			<tr
																				class="
																					software-files
																				">
																				<td>
																					<a
																						class="
																							ts-button
																							is-outlined
																						"
																						:class="{
																							'is-disabled':
																								!software.ableToDownload,
																						}"
																						:href="`/generateLink/${file.software_file_id}`"
																						:download="
																							file.file_title
																						"
																						@click="
																							show_download()
																						"
																						target="_blank">
																						<template
																							v-if="
																								file.type_id ==
																								2
																							">
																							<span
																								class="
																									ts-icon
																									is-book-icon
																								"></span>
																							<div
																								v-if="
																									!software.ableToDownload
																								">
																								<div
																									v-if="
																										software.download_granted ==
																										0
																									">
																									<b
																										>({{
																											$t(
																												"download.downloadInSchool"
																											)
																										}})</b
																									>
																								</div>
																								<div
																									v-else>
																									<b
																										>({{
																											$t(
																												"download.downloadInCC"
																											)
																										}})</b
																									>
																								</div>
																							</div>
																							{{
																								$i18n.locale ==
																								"zh-TW"
																									? file.file_title
																									: file.file_title_en
																							}}
																						</template>

																						<template
																							v-else-if="
																								file.type_id ==
																								1
																							">
																							<span
																								class="
																									ts-icon
																									is-file-arrow-down-icon
																								"></span>
																							<div
																								v-if="
																									!software.ableToDownload
																								">
																								<div
																									v-if="
																										software.download_granted ==
																										0
																									">
																									<b
																										>({{
																											$t(
																												"download.downloadInSchool"
																											)
																										}})</b
																									>
																								</div>
																								<div
																									v-else>
																									<b
																										>({{
																											$t(
																												"download.downloadInCC"
																											)
																										}})</b
																									>
																								</div>
																							</div>
																							{{
																								file.custom_title
																									? file.custom_title
																									: $t(
																											"download.bit." +
																												file.bit_id
																									  ) +
																									  $t(
																											"download.lang." +
																												file.lang_id
																									  )
																							}}
																						</template>
																					</a>
																				</td>

																				<td
																					class="
																						ts-row
																						is-compact
																					">
																					<Popper
																						arrow="true"
																						placement="top"
																						hover="true"
																						:content="
																							file.md5
																						"
																						class="
																							column
																						">
																						<button
																							type="button"
																							class="
																								ts-button
																								is-dense
																								is-outlined
																							"
																							@click="
																								CopyTextToClipboard(
																									`${file.software_file_id}-md5`
																								);
																								copied(
																									`md5`
																								);
																							">
																							<span
																								class="
																									hash_name
																									m-0
																									p-0
																									mb-1
																								"
																								>MD5</span
																							>
																							<span
																								class="
																									ts-icon
																									is-copy-icon
																									is-regular
																								"></span>
																						</button>
																					</Popper>

																					<span
																						style="
																							opacity: 0;
																							font-size: 0px;
																						"
																						:id="`${file.software_file_id}-md5`">
																						{{
																							file.md5
																						}}
																					</span>

																					<Popper
																						arrow="true"
																						placement="top"
																						hover="true"
																						:content="
																							file.sha256
																						"
																						class="
																							column
																						">
																						<button
																							type="button"
																							class="
																								ts-button
																								is-dense
																								is-outlined
																							"
																							@click="
																								CopyTextToClipboard(
																									`${file.software_file_id}-sha256`
																								);
																								copied(
																									`sha256`
																								);
																							">
																							<span
																								class="
																									hash_name
																									m-0
																									p-0
																									mb-1
																								"
																								>SHA256</span
																							>
																							<span
																								class="
																									ts-icon
																									is-copy-icon
																									is-regular
																								"></span>
																						</button>
																					</Popper>

																					<span
																						style="
																							opacity: 0;
																							font-size: 0px;
																						"
																						:id="`${file.software_file_id}-sha256`"
																						>{{
																							file.sha256
																						}}</span
																					>
																				</td>
																			</tr>
																		</template>
																		<template
																			v-for="link in software.links"
																			:key="
																				link.software_link_id
																			">
																			<tr
																				class="
																					software-files
																				">
																				<td>
																					<a
																						:href="`${link.link}`"
																						class="
																							ts-button
																							is-outlined
																						"
																						target="_blank">
																						<span
																							class="
																								ts-icon
																								is-up-right-from-square-icon
																							"></span>

																						{{
																							$i18n.locale ==
																							"zh-TW"
																								? link.link_title
																								: link.link_title_en
																						}}
																					</a>
																				</td>
																				<td
																					class="
																						ts-text
																						is-secondary
																						ts-center
																					">
																					{{
																						$t(
																							"download.notAvailable"
																						)
																					}}
																				</td>
																			</tr>
																		</template>
																	</tbody>
																</table>
															</div>
															<div
																class="
																	column
																	is-5-wide
																"></div>
														</div>
														<div
															class="
																ts-space
															"></div>
														<div
															class="
																ts-space
															"></div>
														<div
															class="
																software_introduction
															"
															v-html="
																$i18n.locale ==
																'zh-TW'
																	? software.introduction
																	: software.introduction_en
															"></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="message != null" class="text-align-center">
						{{ message }}
					</div>
				</template>
				<template v-else>
					<div class="row none_software not-found">
						<h2>{{ $t("download.noSoftware") }}</h2>
						<InertiaLink
							class="btn btn-primary mt-3"
							title="返回下載專區"
							href="/download">
							<span class="ts-icon is-rotate-left-icon"></span>
							{{ $t("download.back") }}
						</InertiaLink>
					</div>
				</template>
			</div>
		</section>
	</frontend-layout>
</template>

<script>
// import components
import FrontendLayout from "@/Frontend/Shared/Layout";
import { format, sub } from "date-fns";
import axios from "axios";
import Popper from "vue3-popper";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
	name: "frontend_software",
	props: {
		softwares: Object,
		softwareCategoryTitle: String,
		softwareCategoryTitleEn: String,
	},
	data() {
		return {
			softwares: this.$props.softwares,
		};
	},
	methods: {
		CopyTextToClipboard(id) {
			var TextRange = document.createRange();
			TextRange.selectNode(document.getElementById(id));
			var sel = window.getSelection();
			sel.removeAllRanges();
			sel.addRange(TextRange);
			document.execCommand("copy");
		},
		show_download() {
			toast.success(this.$t("download.downloading"));
		},
		copied(str) {
			toast.success(str + this.$t("download.copied"));
		},
	},
	mounted() {},
	computed: {},
	components: {
		FrontendLayout,
		Popper,
	},
};
</script>
<style>
:root {
	--popper-theme-background-color: #333333;
	--popper-theme-background-color-hover: #333333;
	--popper-theme-text-color: #ffffff;
	--popper-theme-border-width: 0px;
	--popper-theme-border-style: solid;
	--popper-theme-border-radius: 6px;
	--popper-theme-padding: 1rem;
	--popper-theme-box-shadow: 0 6px 6px -6px rgba(0, 0, 0, 0.25);
}
</style>
<style scoped>
.not-found {
	text-align: center;
}
.software-item {
	border-radius: 1rem;
}
.content {
}
.software-button {
	padding: 0.25rem;
	color: white;
}
.software {
	width: 100%;
}

.software img {
	/* max-width: 200px; */
	width: 100%;
	height: auto;
}

.card-body {
	margin: 0;
	padding: 0;
}
.card-footer {
	background-color: transparent;
	color: black;
	text-decoration: none;
	text-align: center;
}
.software-filter-all,
.software-filter {
	border-radius: 5px;
}
.software-filter-all {
	width: 84px;
	background: #198754;
	text-decoration: none;
	color: white;
}
.software-filter {
	width: 84px;
	background: #0d6efd;
	text-decoration: none;
	color: white;
}
.sort-category {
	display: block;
}
.file_control_button {
	display: inline;
}
.file_table td {
	overflow: hidden;
}

.hidden-box {
	color: black;
	font-size: 18px;
	width: 250px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.software_link_title {
	font-size: 18px;
	color: gray;
	line-height: 1.5rem;
}

.software_link_a {
	color: red;
	text-decoration: underline;
}
.md5-html,
.sha256-html {
	background-color: #183153;
	color: #c3c6d1;
	cursor: grab;
	border-radius: 1rem;
	display: flex;
	vertical-align: center;
}
.token {
	color: white;
}
.download_button {
	text-align: left;
}
</style>
